import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import Paper from '@material-ui/core/Paper';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import ChangeStatusShopDialogConfirm from './ChangeStatusShopDialogConfirm';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  },
  titleModal: {
    marginBottom: 10,
    padding: '0 30px'
  },
  ml50: {
    marginLeft: 50
  },
  rowRadio: {
    display: 'flex',
    flexWrap: 'no-wrap',
    paddingLeft: 15,
    paddingRight: 15
  },
  mainPaper: {
    padding: 20
  },
  boxCheck: {
    borderTop: '1px solid #DDDDDD',
    padding: 15,
    marginTop: 15
  },
  dialogActionLeft: {
    justifyContent: 'flex-start'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    openChangeConfirm,
    updateOpenChangeConfirm,
    cancelAction,
    changeAction,
    disableStatus,
    message,
    setMessage,
    shopConnectSystem,
    updateShopConnectSystem,
    idShopShow
  }) => {
    const changeActionConfirm = () => {
      updateOpenChangeConfirm(true);
      setMessage('そのように設定してもよろしいでしょうか。?');
    };
    const cancelActionConfirm = () => {
      updateOpenChangeConfirm(false);
    };
    const updateStatusShop = value => {
      let isAllShopEnable = false;
      if (value === '1') {
        isAllShopEnable = true;
      }
      const nShopConnectSystem = { ...shopConnectSystem };
      nShopConnectSystem.isAllShopEnable = isAllShopEnable;
      updateShopConnectSystem(nShopConnectSystem);
      console.log('nShopConnectSystem', nShopConnectSystem);
    };
    const handleChange = (connectSystemId, value) => {
      let showFlag = 0;
      if (!value) {
        showFlag = 1;
      }
      const newShopConnectSystem = { ...shopConnectSystem };
      for (
        let index = 0;
        index < newShopConnectSystem.shopConnectSystems.length;
        index += 1
      ) {
        if (
          newShopConnectSystem.shopConnectSystems[index].connectSystemId ===
          connectSystemId
        ) {
          newShopConnectSystem.shopConnectSystems[index].showFlag = showFlag;
        }
      }
      updateShopConnectSystem(newShopConnectSystem);
    };
    return (
      <Dialog
        open={openChange}
        onClose={() => {
          updateOpenChange(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialogChange}
      >
        <DialogContent>
          <Typography component="p" className={classes.titleModal}>
            社食ごちめし法人表示設定
          </Typography>
          <Paper className={classes.mainPaper} elevation={1}>
            <RadioGroup
              value={shopConnectSystem.isAllShopEnable ? 1 : 0}
              onChange={e => {
                updateStatusShop(e.target.value);
              }}
            >
              <div className={classes.rowRadio}>
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary" disabled={disableStatus} />}
                  label="特定の法人のみで表示"
                />
                <FormControlLabel
                  value={1}
                  control={
                    <Radio
                      color="primary"
                      disabled={disableStatus || shopConnectSystem.isEduShop}
                    />
                  }
                  label="全ての法人で表示"
                  className={classes.ml50}
                />
              </div>
            </RadioGroup>
            {!shopConnectSystem.isAllShopEnable && (
              <>
                <div className={classes.boxCheck}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    {/* <FormLabel component="legend">
                        Assign responsibility
                      </FormLabel> */}
                    {Object.keys(shopConnectSystem).length !== 0 &&
                      shopConnectSystem.shopConnectSystems.map(company => {
                        return (
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={company.showFlag}
                                  color="primary"
                                  onChange={() => {
                                    handleChange(
                                      company.connectSystemId,
                                      company.showFlag
                                    );
                                  }}
                                  name="company"
                                />
                              }
                              label={company.connectSystemName}
                            />
                          </FormGroup>
                        );
                      })}
                  </FormControl>
                </div>
              </>
            )}
          </Paper>
        </DialogContent>
        <DialogActions className={classes.dialogActionLeft}>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ChangeButton
            onClickAction={changeActionConfirm}
            enabled={!disableStatus}
          />
        </DialogActions>
        <ChangeStatusShopDialogConfirm
          message={message}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          cancelAction={cancelActionConfirm}
          changeAction={changeAction}
          idShopShow={idShopShow}
        />
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
